import { DmsSyncQueueLogRequestModel } from './../business-entities/dms-sync-queue-log-request-model';
import { Injectable } from "@angular/core";
import { WeekDays } from 'projects/Autofacets-Core/src/app/utils/enums';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { DMSSyncFailedlogDataService } from "../data-services/dms-sync-failed-log-data.service";
import { DMSSyncFailedLogRequestModel } from "../business-entities/dmssyncfailedlog-request-model";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { VehicleBusinessService } from "./vehicle-service";
import { CustomerService } from "./customer.service";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgbdModalContent } from "projects/Autofacets-Core/src/app/shared/delete-modal.component";
import * as Enums from './../../../../Autofacets-Core/src/app/utils/enums';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})

export class DMSSyncFailedlogService {

  filterTypeId: number = 0;
  dmsSyncQueueLogRequestModel: any;

  constructor(private service: DMSSyncFailedlogDataService,
    private modalService: NgbModal,
    private customerService: CustomerService,
    private vehicleService: VehicleBusinessService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,) {
  }

  GetDmsSyncFailedLog(smsLogRequestModel: DMSSyncFailedLogRequestModel): Promise<GenericResponse<any>> {
    return this.service.GetDmsSyncFailedLog(smsLogRequestModel);
}

  GetAfxSyncFailedLog(smsLogRequestModel): Promise<GenericResponse<any>> {
    return this.service.GetAfxSyncFailedLog(smsLogRequestModel);
  }

  GetDmsSyncQueueLog(dmsSyncQueueLogRequestModel:DmsSyncQueueLogRequestModel): Promise<GenericResponse<any>> {
    return this.service.GetDmsSyncQueueLog(dmsSyncQueueLogRequestModel);
  }
  DeleteQueue(rowId: number, deleteFrom:string) {
    return this.service.DeleteQueue(rowId, deleteFrom);
}
  getDayText(dayId: number): string {
    switch (dayId) {
      case WeekDays.Sunday:
        return 'Sunday';
      case WeekDays.Monday:
        return 'Monday';
      case WeekDays.Tuesday:
        return 'Tuesday';
      case WeekDays.Wednesday:
        return 'Wednesday';
      case WeekDays.Thursday:
        return 'Thursday';
      case WeekDays.Friday:
        return 'Friday';
      case WeekDays.Saturday:
        return 'Saturday';
      default:
        return '';
    }
  }

  onSyncToDms(moduleId, id, name, requsetModel, environment){
    let modelHeadermsg = this.translate.instant("lblSyncToDMS");
    let modelBodymsg = this.translate.instant("lblSureToSyncOnEnvironment:");
    modelBodymsg = modelBodymsg?.replace('{environment}',environment);
    let successMsg = this.translate.instant('lblSyncSuccess')
    let errorMsg = this.translate.instant('lblErrormsg');
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {  // This is intentional
    }, (reason) => {
      let popupCloseResult = this.getDismissDeleteReason(reason);
      if (popupCloseResult) {

        if (moduleId == Enums.ModuleNames.Customer) {
          this.spinner.show();
          this.customerService.ResyncCustomer(id, Enums.ModuleNames.Customer).then((res) => {
            this.spinner.hide();
            if (res.responseObject.isSuccess) {
              this.toastr.success(successMsg);
              this.GetDmsSyncFailedLog(requsetModel);
            } else {
              this.toastr.error(errorMsg);
            }
          });
        } else if (moduleId == Enums.ModuleNames.Vehicle) {
          this.spinner.show();
          this.vehicleService.ResyncVehicle(name, Enums.ModuleNames.Vehicle).then((response) => {
            this.spinner.hide();
            if (response.responseObject.isSuccess) {
              this.toastr.success(successMsg);
              this.GetDmsSyncFailedLog(requsetModel);
            } else {
              this.toastr.error(errorMsg);
            }
          });
        }

      }
    });
  }

  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  GetModuleNamesList(): Promise<GenericResponse<any>> {
    return this.service.GetModuleNamesList();
}

}
